var _radialGradient, _path, _path2, _path3, _radialGradient2, _path4, _path5, _radialGradient3, _path6, _path7, _radialGradient4, _path8, _path9, _radialGradient5, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotApprovalPack2 = function SvgNotApprovalPack2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "not-approval-pack2_svg__a",
    cx: 51.77,
    cy: 31.4,
    r: 87.04,
    gradientTransform: "matrix(-.00218 -1 -.7873 .00172 76.6 148.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-approval-pack2_svg__a)",
    d: "M62.05 122.19c-2.51 0-4.87-.72-7.01-2.13-.88-.58-.88-4.62-.87-7.86.01-5.02.02-11.27-2-16.99a34.28 34.28 0 0 0-10.68-15c-9.9-7.74-23.03-12.02-23.59-12.2a9.05 9.05 0 0 1-7.92-9.07l.08-32.75c.01-4.89 3.43-9.1 8.31-10.26.63-.15 1.39-.24 2.19-.34 1.87-.23 3.99-.5 5.94-1.6 6.88-3.9 15.94-5.21 24.71-6.04a417.03 417.03 0 0 1 34.32-1.61c3 0 5.73 1.13 7.78 3.19a10.82 10.82 0 0 1 3.18 7.69l-.05 42.21a14.83 14.83 0 0 1-14.81 14.79h-.13l-7.25-.25a1.5 1.5 0 0 0-1.4.97c-1.49 3.95.16 9.76 2.06 16.49 1.61 5.69 3.27 11.57 3.06 16.54-.32 7.18-8.2 14.22-15.92 14.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M85.61 7.83c2.51 0 4.86.98 6.63 2.75s2.74 4.12 2.74 6.63l-.05 42.21a13.33 13.33 0 0 1-13.31 13.3h-.06l-7.2-.25h-.11a3 3 0 0 0-2.81 1.94c-1.66 4.41.04 10.44 2.02 17.42 1.58 5.57 3.21 11.34 3 16.07-.28 6.34-7.55 12.79-14.41 12.79a11 11 0 0 1-5.97-1.75c-.42-1-.41-4.3-.41-6.74.01-5.13.02-11.52-2.09-17.5a35.74 35.74 0 0 0-11.17-15.68c-10.11-7.9-23.49-12.27-24.05-12.45-.15-.05-.3-.08-.45-.11a7.56 7.56 0 0 1-6.42-7.54l.08-32.75a9.12 9.12 0 0 1 7.15-8.8c.56-.13 1.27-.22 2.03-.32 1.91-.24 4.29-.54 6.49-1.78 6.64-3.76 15.51-5.03 24.11-5.85a413.07 413.07 0 0 1 34.19-1.6l.07.01m0-3h-.1c-9.04.07-21.85.43-34.45 1.62-10.18.96-18.68 2.47-25.31 6.22-2.48 1.41-5.51 1.26-7.73 1.79a12.13 12.13 0 0 0-9.46 11.71l-.08 32.76a10.6 10.6 0 0 0 8.96 10.51s13.32 4.29 23.12 11.96a32.64 32.64 0 0 1 10.19 14.32c3.74 10.58.23 23.46 3.46 25.6a14.03 14.03 0 0 0 7.84 2.38c8.74 0 17.07-7.86 17.41-15.66.48-10.99-7.71-25.93-5.21-32.57l7.24.25h.12c8.99 0 16.3-7.29 16.31-16.29l.05-42.21A12.36 12.36 0 0 0 85.61 4.83z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M66.12 65.5c1.88-5 1.9-12.8 0-17.62-2.75-6.96-9.48-13.05-17.25-14.12-1.9-.26-.77-2.01 1.12-1.75 8.41 1.16 19.79 4.57 22.75 12.12 8.12 20.75-1.38 31.62-5.62 28.38-2.04-1.58-2.06-4.18-1-7.01z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "not-approval-pack2_svg__b",
    cx: 2621.1,
    cy: -453.3,
    r: 20.33,
    gradientTransform: "matrix(-1.3883 -.0794 -.0374 .6794 3724.9 585.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-approval-pack2_svg__b)",
    d: "M95.63 78.7c-13.12 0-22.44-2.21-26.22-6.23a6.9 6.9 0 0 1-1.96-5.43c.43-7.41 10.49-8.96 18.84-8.96a104.69 104.69 0 0 1 18.91 1.97c4.39.26 7.72 4.58 7.42 9.63-.29 4.89-3.84 8.72-8.09 8.72l-.41-.01h-.09l-.13.01c-.04-.01-3.51.3-8.27.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M86.28 59.58c9.16 0 18.29 1.89 18.38 1.91.14.03.29.05.44.06 1.66.1 3.19.94 4.32 2.38a8.38 8.38 0 0 1 1.69 5.67c-.24 4.09-3.13 7.3-6.59 7.3l-.32-.01-.17-.01-.27.01c-.03 0-3.45.3-8.13.3-12.52 0-21.68-2.1-25.13-5.76a5.47 5.47 0 0 1-1.56-4.32c.1-1.64.7-4.02 4.81-5.7 3-1.21 7.21-1.83 12.53-1.83m0-3c-9.81 0-19.85 2.06-20.34 10.37-.67 11.52 18.27 13.25 29.69 13.25 4.89 0 8.4-.32 8.4-.32l.5.01c5.01 0 9.25-4.42 9.58-10.13.34-5.89-3.61-10.91-8.83-11.22 0 .01-9.39-1.96-19-1.96z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "not-approval-pack2_svg__c",
    cx: 2719.2,
    cy: -648.52,
    r: 18.75,
    gradientTransform: "matrix(-1.6967 .00188 .00291 .6804 4723 486.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-approval-pack2_svg__c)",
    d: "M92.55 60.18c-10.91 0-23.91-1.83-23.91-10.57 0-8.73 13-10.57 23.91-10.57 9.26 0 17.68 1.35 17.76 1.36l.24.02c4.21 0 7.48 5.12 7.48 9.53 0 4.18-3.07 8.84-7.48 8.84l-.24.02c-.09.02-8.51 1.37-17.76 1.37z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M92.55 40.55c9.12 0 17.44 1.33 17.52 1.34.16.03.32.04.48.04 3.22 0 5.98 4.41 5.98 8.03 0 3.47-2.56 7.34-5.98 7.34-.16 0-.32.01-.48.04-.08.01-8.38 1.34-17.52 1.34-6.83 0-12.26-.72-16.15-2.15-5.61-2.06-6.26-4.94-6.26-6.92 0-1.99.65-4.86 6.26-6.92 3.88-1.42 9.32-2.14 16.15-2.14m0-3c-11.93 0-25.41 2.19-25.41 12.07s13.47 12.07 25.41 12.07c9.49 0 18-1.38 18-1.38 5.16 0 8.98-5.23 8.98-10.34s-3.82-11.03-8.98-11.03c0-.01-8.52-1.39-18-1.39z"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "not-approval-pack2_svg__d",
    cx: 2763.2,
    cy: -460.57,
    r: 20.45,
    gradientTransform: "matrix(-1.3069 .00626 .00452 .6804 3714.6 311.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-approval-pack2_svg__d)",
    d: "M91.85 24.59c-15.66 0-24.64-3.01-24.66-8.26 0-1.38.54-2.6 1.67-3.73 6.45-6.47 27.79-6.8 32-6.8l.98.01c4.91 0 8.86 4.11 8.88 9.15a9.31 9.31 0 0 1-2.58 6.52 8.58 8.58 0 0 1-6.2 2.69l-.13.01c-.05.01-4.39.41-9.96.41z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "m100.86 7.31.95.01h.09c4.02 0 7.3 3.44 7.31 7.66a7.82 7.82 0 0 1-2.16 5.48 7.1 7.1 0 0 1-5.12 2.23l-.27.01c-.04 0-4.3.4-9.8.4-14.27 0-23.15-2.59-23.16-6.76 0-.61.12-1.55 1.23-2.66 2.92-2.95 12.77-6.37 30.93-6.37m0-3c-5.86 0-35.2.57-35.16 12.03.03 8.31 15.45 9.75 26.16 9.75 5.71 0 10.08-.41 10.08-.41 5.69-.02 10.29-4.82 10.27-10.72-.02-5.89-4.63-10.65-10.31-10.65h-1.04z"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "not-approval-pack2_svg__e",
    cx: 2740.2,
    cy: -625.68,
    r: 18.61,
    gradientTransform: "matrix(-1.6358 .00188 .0028 .6804 4589.2 452.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-approval-pack2_svg__e)",
    d: "M91.29 41.26c-8.98 0-24.06-1.19-24.06-9.12 0-9.45 20.9-10.47 29.89-10.47 5.23 0 9.07.31 9.11.31h.12c4.73 0 9.03 5 9.03 10.5 0 5.81-4.87 7.87-9.03 7.87l-.19.01c-.07.03-6.94.9-14.87.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA600",
    d: "M97.12 23.18c5.15 0 8.95.31 8.99.31l.25.01c3.87 0 7.53 4.37 7.53 9 0 4.7-3.89 6.37-7.53 6.37l-.39.02c-.07.01-6.85.88-14.68.88-6.81 0-12.27-.63-16.21-1.87-6.34-2-6.34-4.82-6.34-5.75 0-3.04 3.02-5.38 8.97-6.97 6.16-1.66 13.96-2 19.41-2m0-3c-11.99 0-31.39 1.6-31.39 11.97 0 8.8 14 10.62 25.56 10.62 8.13 0 15.06-.9 15.06-.9 5.64 0 10.53-3.2 10.53-9.37s-4.89-12-10.53-12c0 0-3.88-.32-9.23-.32zM27.79 13.1 23 32l-2-17z"
  })));
};
export default SvgNotApprovalPack2;